// src/components/ContactUsModal.js
import React from 'react';
import {
    Modal, Box, Typography, IconButton, Link, useTheme, alpha
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email'; // Or ContactMailIcon

const style = (theme) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 400, md: 500 }, // Responsive width
    bgcolor: 'background.paper',
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius * 2, // Softer corners
    boxShadow: 24,
    p: 4, // Padding inside the modal
    outline: 'none', // Remove default focus outline
    background: `linear-gradient(to bottom, ${alpha(theme.palette.primary.light, 0.85)}, ${alpha(theme.palette.common.white, 1)})`,
});

const emailAddress = 'golfteebot@gmail.com';
const mailtoLink = `mailto:${emailAddress}?subject=TeeBot Inquiry`;

// Accept BackdropProps as a prop
function ContactUsModal({ open, onClose, BackdropProps }) { // <-- Added BackdropProps here
    const theme = useTheme();

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="contact-us-modal-title"
            aria-describedby="contact-us-modal-description"
            BackdropProps={BackdropProps} // <-- Passed BackdropProps to the internal Modal
        >
            <Box sx={style(theme)}>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <Typography id="contact-us-modal-title" variant="h6" component="h2" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                     <EmailIcon sx={{ mr: 1, color: 'primary.main' }} /> Contact Us
                </Typography>
                <Typography id="contact-us-modal-description" sx={{ mt: 2, mb: 1 }}>
                    We'd love to hear from you!
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    <b>Golf Course Owners/Managers:</b> Interested in adding your course to TeeBot? Please email us.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                    <b>General Inquiries:</b> Have questions, feedback, or suggestions? Let us know!
                </Typography>
                <Typography variant="body1" sx={{ textAlign: 'center' }}>
                    Please reach out to:
                    <br />
                    <Link href={mailtoLink} underline="hover" sx={{ fontWeight: 'bold', display: 'inline-flex', alignItems: 'center', mt: 1 }}>
                          <EmailIcon sx={{ fontSize: '1.1rem', mr: 0.5 }} /> {emailAddress}
                    </Link>
                </Typography>
            </Box>
        </Modal>
    );
}

export default ContactUsModal;